import Pages from "./pages/Pages";
import "./App.scss";
import "./Reset.scss";
function App() {
  return (
    <div className="App">
      <Pages />
    </div>
  );
}

export default App;
